import React from 'react';
import './App.css';  // Import the global CSS styles


import Header from './components/Header';
import Home from './components/Home.js';
import About from './components/About.js';
import Skills from './components/Skills.js';
import Portfolio from './components/Portfolio.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <div className="main-container">
      <Header />
      <Home />
      <About />
      <Skills />
      <Portfolio />
      <Contact />
      <Footer />

    </div>
  );
}

export default App;
